import { useTranslation } from 'react-i18next';

import { Box, HStack, InformationCircleOutline, Switch, Text, Tooltip } from '@bonusly/design-system';

import { useReduceBizyMotionPreference } from '../bizy';
import { useBizySettingsDraftStore } from './store/use-bizy-settings-draft-store';

export const MotionSection = () => {
	const { t } = useTranslation('admin_bizy', { keyPrefix: 'settingsPanel.motion' });
	const [reduceBizyMotion] = useReduceBizyMotionPreference();

	const draft = useBizySettingsDraftStore((state) => state.pendingReduceMotion);
	const setPendingReduceMotion = useBizySettingsDraftStore((state) => state.setPendingReduceMotion);
	const clearPendingReduceMotion = useBizySettingsDraftStore((state) => state.clearPendingReduceMotion);

	const displayValue = draft !== null ? draft : reduceBizyMotion;

	const handleChange = (nextValue: boolean) => {
		if (nextValue === reduceBizyMotion) {
			clearPendingReduceMotion();
		} else {
			setPendingReduceMotion(nextValue);
		}
	};

	return (
		<Box py={3} borderBottom="1px solid" borderColor="border.soft">
			<HStack spacing={3} align="center" justify="space-between">
				<HStack spacing={1.5}>
					<Text size="sm" variant="medium" color="text.soft">
						{t('reduceMotionLabel')}
					</Text>
					<Tooltip label={t('reduceMotionDescription')} hasArrow={false}>
						<Box as="span" display="inline-flex" alignItems="center">
							<InformationCircleOutline size="xs" color="text.softest" />
						</Box>
					</Tooltip>
				</HStack>
				<Switch aria-label={t('reduceMotionAriaLabel')} isChecked={displayValue} onChange={(event) => handleChange(event.target.checked)} flexShrink={0} />
			</HStack>
		</Box>
	);
};
